import getEnv from "../config";

const EXTERNAL_KEYCLOAK = getEnv("REACT_APP_EXTERNAL_KEYCLOAK") === "true";
const DEFAULT_ORGANIZATION = getEnv("REACT_APP_DEFAULT_ORGANIZATION", "default_org");

export function isOrgAdmin(keycloak) {
  if (EXTERNAL_KEYCLOAK) return true;
  const roles = keycloak?.tokenParsed?.roles || keycloak?.tokenParsed?.realm_access?.roles || [];
  return roles.includes("organization-admin");
}

export function getOrganization(keycloak) {
  return keycloak?.tokenParsed?.organization || DEFAULT_ORGANIZATION;
}

export function isExternalKeycloak() {
  return EXTERNAL_KEYCLOAK;
}
